<template>
    <v-container fluid>
        <v-row cols="12" dense>
            <v-col cols="9">
                <h2>{{ this.title }}</h2>
            </v-col>
            <v-col cols="1">
                <btn_component data="" type="text" text="Prompts" tooltip="Update prompts" size="small" @actionClick="stdPrompts"/>
            </v-col>
            <v-col cols="1">
                <btn_component data="" type="text" text="Preferred Q&A" tooltip="Update preferred questions & answers" size="small" @actionClick="stdQuestions"/>
            </v-col>
            <!-- <v-col cols="1">
                <btn_component data="" type="text" text="User questions" tooltip="User questions" size="small" @actionClick="userQuestions"/>
            </v-col> -->
        </v-row>
        <v-row dense cols="12">
            <v-col cols="2" class="pt-2">
                <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail dense/>
            </v-col>
            <v-col cols="2" class="pt-2">
                <v-select v-model="status" :items="statusses" item-value="Option" item-text="Description"  label="Status" small-chips multiple clearable dense></v-select>
            </v-col>
            <v-col cols="2" class="pt-2">
                <v-select v-model="remark" :items="remarks" item-value="Option" item-text="Description" label="Remark" small-chips clearable dense></v-select>
            </v-col>
            <v-col cols="2" class="pt-2">
                <v-select v-model="rating" :items="ratings" item-value="Option" item-text="Description" label="Rating" small-chips multiple clearable dense></v-select>
            </v-col>
            <v-col cols="2" class="pt-2">
                <v-select v-model="category" :items="categories" item-value="Option" item-text="Description" label="Category" small-chips multiple clearable dense></v-select>
            </v-col>
            <v-col cols="2" class="pt-2">
                <v-select v-model="source" :items="sources" item-value="Option" item-text="Description" label="Source" small-chips multiple clearable dense></v-select>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="row-default">
            <v-col cols="12" class="px-2">
                <v-data-table id="x" 
                    dense 
                    :headers="getQuestionsHeaders()" 
                    :items="filteredQuestions" 
                    :disable-pagination=true
                    hide-default-footer 
                    item-key="oavr_nr" 
                    :loading="loading"
                    loading-text="Loading data...please wait" 
                    fixed-header 
                    :search="search"
                    :height="wInnerHeight"
                    >
                    <template v-slot:item="question">
                        <tr @click="procesQuestion(question.item)" >
                            <td>{{ question.item.oavr_nr }}</td>
                            <td>{{ question.item.oavr_received_dt.replace("T", " ").substring(0, 16) }}</td>
                            <td>{{ question.item.oavr_status }}</td>
                            <td>
                                <v-tooltip bottom v-if="question.item.oavr_reject_oms!==''">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">{{ question.item.oavr_rating }}</span>
                                    </template>
                                    <span>{{ question.item.oavr_reject_oms }}</span>
                                </v-tooltip>
                                <div v-else>{{ question.item.oavr_rating }}</div>                                              
                            </td>
                            <td>
                                <v-tooltip bottom v-if="question.item.oact_oms!==''">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">{{ question.item.oact_code }}</span>
                                    </template>
                                    <span>{{ question.item.oact_oms }}</span>
                                </v-tooltip> 
                                <div v-else>{{ question.item.oact_code }}</div>                                                      
                            </td>
                            <td>{{ question.item.oavr_bron }}</td>
                            <td>{{ question.item.oavr_key }}</td>
                            <td>
                                <v-tooltip bottom v-if="question.item.oavr_opm_intern!==''">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on"><v-icon>mdi-email-alert</v-icon></span>
                                    </template>
                                    <span>{{ question.item.oavr_opm_intern }}</span>
                                </v-tooltip>                                
                            </td>
                            <td>
                                <v-tooltip bottom v-if="question.item.oavr_antwoord!==''">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">{{ question.item.oavr_vraag }}</span>
                                    </template>
                                    <span>{{ question.item.oavr_antwoord }}</span>
                                </v-tooltip>
                                <div v-else>{{ question.item.oavr_vraag }}</div>                                  
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";

    export default {
        components: {
            btn_component,
        },    
        props: {
            wInnerHeight: {
                type: Number,
                required: true,
            }
        },
        data() {
            return {
                loading: false,
                title: "(Pending) questions overview",
                search: "",
                text_max_width: 150,     // For all long texts
                questions: [],

                // Selected sources & source options
                source: [],    
                sources: [],

                // Selected categories & category options
                category: [],
                categories: [],

                // Selected rating & rating options
                rating: [],
                ratings: [],

                // Selected statusses & status options
                status: ["ExpertReview"],
                statusses: [],
                
                // Selected rating & rating options
                remark: [],
                remarks: [{
                    "Option": "All",
                    "Description": "All questions",
                }, {
                    "Option": "Remarks",
                    "Description": "Remarks only",
                }],
            }
        },    
        computed: {
            filteredQuestions: function() {            
                return this.questions.filter((question) => {
                    if (!this.match_field(this.source, question.oavr_bron)) {
                        return false;
                    }
                    if (!this.match_field(this.category, question.oact_code)) {
                        return false;
                    }
                    if (!this.match_field(this.status, question.oavr_status)) {
                        return false;
                    }
                    if (!this.match_field(this.rating, question.oavr_rating)) {
                        return false;
                    }
                    if (this.remark === "Remarks") {
                        if (question.oavr_opm_intern === '') {
                            return false;
                        }
                    }
                   
                    return true;
                })
            }     
        }, 
        mounted() {
            this.getFilters();
            this.getQuestionsOverview();
        },
        methods: {
            getFilter(name, defaultValue) {
                if (sessionStorage.getItem(name) === null) {
                    return defaultValue;
                } else {
                    return JSON.parse(sessionStorage.getItem(name));
                }
            },
            getFilters() {
                this.search = sessionStorage.getItem("pending_search") === null ? "" : sessionStorage.getItem("pending_search");
                this.source = this.getFilter("pending_source", []);
                this.category = this.getFilter("pending_category", []);
                this.rating = this.getFilter("pending_rating", []);
                this.remark = this.getFilter("pending_remark", []);
                this.status = this.getFilter("pending_status", ["ExpertReview"]);
            },  
            setFilter(name, data) {
                sessionStorage.setItem(name, JSON.stringify(data));
            },
            setFilters() {
                sessionStorage.setItem("pending_search", this.search);
                this.setFilter("pending_source", this.source);
                this.setFilter("pending_category", this.category);
                this.setFilter("pending_rating", this.rating);
                this.setFilter("pending_status", this.status);
                this.setFilter("pending_remark", this.remark);
            },  
            match_field(options, value) {
                if (options.length === 0) { return true } 
                for(let idx=0; idx < options.length; idx++) {                         
                    if(options[idx] === value) {
                        return true;
                    }
                }
                return false;                
            },
            getQuestionsOverview() {
                this.loading = true;
                this.$axios.post("ares/json/ares/task/customer_success/openai/getQuestionsOverview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getQuestionsOverview"
                    },
                    getQuestionsOverview: {
                    }
                }).then(res => {
                    if (res.data.header.error) {
                        console.log(res.data.error);
                    } else {
                        this.categories = res.data.oact;
                        this.statusses = res.data.status_codes;
                        this.sources = res.data.source_codes;
                        this.ratings = res.data.rating_codes;
                        this.questions = res.data.getQuestionsOverview;
                    }
                    this.loading = false;
                });
            },            
            getQuestionsHeaders() {
                return [
                    { text: "Nr", value: "oavr_nr", sortable: true, width: '4%' },
                    { text: "Received", value: "oavr_received_dt", sortable: true, width: '8%' },
                    { text: "Status", value: "oavr_startus", sortable: true, width: '7%' },
                    { text: "Rating", value: "oavr_rating", sortable: true, width: '7%' },
                    { text: "Category", value: "oact_code", sortable: true, width: '7%' },
                    { text: "Source", value: "oavr_bron", sortable: true, width: '7%' },
                    { text: "Code", value: "oavr_key", sortable: true, width: '7%' },
                    { text: "Remark", value: "oavr_opm_intern", sortable: true, width: '5%' },
                    { text: "Question", value: "oavr_vraag", sortable: true, width: '45%' },
                ];
            },
            procesQuestion(question) {
                this.setFilters();
                this.$emit("updateView", question.oavr_nr);
            },
            stdPrompts() {
                this.setFilters();
                 let route = this.$router.resolve({ path: "/task/customer_success/openai/prompts/questions"}); 
                 window.open(route.href, '_self');
            },
            stdQuestions() {
                this.setFilters();
                 let route = this.$router.resolve({ path: "/task/customer_success/openai/std_questions"}); 
                 window.open(route.href, '_self');
            },
            userQuestions() {
                 this.setFilters();
                 let route = this.$router.resolve({ path: "/task/customer_success/openai/user_questions"}); 
                 window.open(route.href, '_self');
            },
        }
    }
</script>

<style scoped> 
    .row-default {
        cursor: default;
    }
    .row-pointer {
        cursor: pointer;
    }
    .subtitle-weight {
        font-weight: 400;
    }
</style>